import Modal from '@/components/ui/Modal/Modal';

export default Modal;
